import { render, staticRenderFns } from "./addClassWorkModal.vue?vue&type=template&id=6f1e05ed&scoped=true"
import script from "./addClassWorkModal.vue?vue&type=script&lang=js"
export * from "./addClassWorkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1e05ed",
  null
  
)

export default component.exports